exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guestRoomTable i.el-icon-check {\n  font-size: 20px;\n  color: #67c23a;\n}\n.guestRoomTable i.el-icon-close {\n  font-size: 20px;\n  color: #f56c6c;\n}\n.guestRoomTable .page {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  width: 100%;\n}\n", ""]);

// exports
